<!--
 * @Name: PwdWarn
 * @Description: 密码提醒
 * @Author: xiadongxue
 * @Date: 2022-04-27 12:05:18
 * @Editors: xiadongxue
-->
<template>
<el-popover
    popper-class="newPwd-popover"
    placement="bottom-start">
    <div>您的密码必须包含：</div>
    <div
        class="pwd-reg"
        :class="{'reg-true': reg1.test(pwd)}">
        <i class="el-icon-circle-check"></i>
        至少8个字符
    </div>
    <div
        class="pwd-reg"
        :class="{'reg-true': reg2.test(pwd)}">
        <i class="el-icon-circle-check"></i>
        大写与小写字母
    </div>
    <div
        class="pwd-reg"
        :class="{'reg-true': reg3.test(pwd)}">
        <i class="el-icon-circle-check"></i>
        至少1个数字
    </div>
    <div class="pwd-strength">
        <div :class="{'active': score >= 5}">低</div>
        <div :class="{'active': score >= 15}">中</div>
        <div :class="{'active': score >= 20}">高</div>
    </div>
    <el-input
        :style="{'width': edit ? '300px' : '260px'}"
        slot="reference"
        clearable
        @input="inputChange"
        v-model="value"
        :size="edit ? 'small' : 'medium'"
        show-password
        :placeholder="edit ? '' : '请输入密码'"
        type="password"></el-input>
</el-popover>
</template>

<script>
export default {
    name: 'pwdWarn',
    props: {
        pwd: {
            type: String,
            default: ''
        },
        //区分引用
        edit: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: '',
            reg1: /(?=.{8,})/,
            reg2: /(?=.*[A-Z]{1,})(?=.*[a-z]{1,})/,
            reg3: /(?=.*\d)/
        }
    },
    computed: {
        score() {
            let modes = 0
            if(this.reg1.test(this.value)) {
                modes += 5
            }
            if(this.reg2.test(this.value)) {
                modes += 5
            }
            if(this.reg3.test(this.value)) {
                modes += 5
            }
            if(/\W/g.test(this.value)) {
                modes += 5
            }
            return modes
        }
    },
    methods: {
        inputChange(value) {
            this.$emit('update:pwd',value)
        }
    },
    watch: {
        show(val) {
            if(!val) {
                this.value = ''
            }
        }
    }
}
</script>
<style lang="scss">
.pwd-strength {
    display: flex;
    align-items: center;
    text-align: center;
    line-height: 20px;
    padding-top: 10px;
    div {
        width: 100px;
        height: 20px;
        margin-right: 5px;
        background: #ddd;
        &.active {
            background: #67c23a;
            color: #fff;
        }
    }
}
</style>
